import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import API_REST from '../../../api-rest-uruk';

const DownloadButton = ({ document }) => {
  const { t } = useTranslation();
  const flow = JSON.parse(document.flow);

  const downloadCertificate = async () => {
    API_REST.getCertificate(flow.flowId)
      .then(response => window.open(response, '_blank'))
      .catch(err => console.error('[ERROR]: ', err));
  };

  return (
    <Button
      variant='contained'
      color='primary'
      disabled={!flow || flow.status === 'sendToSign'}
      onClick={downloadCertificate}
    >
      {t('certificate:list:downloadCertificate')}
    </Button>
  );
};

DownloadButton.propTypes = {
  document: PropTypes.object.isRequired
};

export default DownloadButton;
